import { ComponentRendering, Placeholder, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import breakpoints from '../../../constants/breakpoints.constants';
import ctaTypes from '../../../enums/CTA.enums';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import CTA from '../CTA';
import { CustomText } from '../customText';
import MediaCarousel from '../mediaCarousel';
import { SplitModuleContainerModel } from './models/splitModuleContainer.model';
import { SplitModuleContainerProps } from './types/splitModuleContainer.types';
import DownloadCTA from '../downloadCTA';
import UnreleasedComponent from '../unreleasedComponent';
import './index.scss';

const SplitModuleContainer: FC<SplitModuleContainerProps> = (props) => {
  const isEE = props?.sitecoreContext?.pageEditing;
  const model = new SplitModuleContainerModel(props);
  const hasSecondaryCta = model?.link2?.value?.text && model?.link2?.value?.href;
  const noOfCards = model.items?.length || 0;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <div className={`split-module ${model?.imagePosition === 'right' && 'split-module--right'}`}>
      {noOfCards > 0 && <MediaCarousel slides={model.slides} mediaHeightClassName="split-module__media-height" />}

      <div className={'split-module__column split-module__content'}>
        <Text tag="p" field={model?.eyebrow} className={'split-module__eyebrow'} />
        <CustomText tag={model.headingTag} field={model?.title} className={'split-module__title'} />
        <RichText tag="div" field={model?.bodyText} className={'split-module__text rich-text color-inherit-link'} />

        <div className={'split-module__link-wrapper'}>
          {(isEE || (model?.link1?.value?.text && model?.link1?.value?.href)) && (
            <CTA field={model.link1} target={targetLinkdsk(model?.link1, isDesktop)} type={ctaTypes['primaryOrange']} />
          )}
          {(isEE || hasSecondaryCta) && (
            <CTA field={model.link2} target={targetLinkdsk(model?.link2, isDesktop)} type={ctaTypes['secondaryBlack']} />
          )}
          {!hasSecondaryCta && model.downloadButtonLink && (
            <DownloadCTA field={model.downloadButtonLink} type={ctaTypes['secondaryBlack']} />
          )}
          <div className="split-module__pop-up">
            <Placeholder name={'jss-generic-popup'} rendering={props.rendering as ComponentRendering} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SplitModuleContainer;
